import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getnews, createnews, updatenews, deletenewss } from '../../ReduxToolkit/Slice/Blog/News';
import JoditEditor from 'jodit-react';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';


function News() {
    const dispatch = useDispatch();
    const { status, newss } = useSelector((state) => state.news);
    const [Image, setImage] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [startdate, setstartdate] = useState("");
    const [enddate, setenddate] = useState("");
    const closeButtonRef = useRef(null);
    const [isDescriptionValid, setIsDescriptionValid] = useState(true);
    // create
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!content) {
            setIsDescriptionValid(false);
            return;
        }
        setIsDescriptionValid(true);
        const formData = new FormData();
        formData.append('Image', Image === null ? "" : Image);
        formData.append('title', title);
        formData.append('content', content);
        formData.append('startdate', startdate);
        formData.append('enddate', enddate);
        dispatch(createnews(formData));
        setImage(null);
        setTitle("");
        setContent("");
        setstartdate("");
        setenddate("");
        closeButtonRef.current.click();


    };
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getnews())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (newsid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this news?")
        if (Isconfirmed) {
            dispatch(deletenewss(newsid))
        };
    }
    // single data fetch
    const [updateButton, setupdateButton] = useState("d-none")
    const [SubmitButton, setSubmitButton] = useState("")
    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectenews = newss.data.find(news => news._id === id);
        setTitle(selectenews.title);
        setImage(selectenews.Image);
        setContent(selectenews.content);
        setstartdate(selectenews.startdate);
        setenddate(selectenews.enddate);
        setSelectedId(id);
        if (selectenews) {
            setupdateButton("")
            setSubmitButton("d-none")
        }
        else { }
    };
    // update
    const handleEdit = () => {
        const formData = new FormData();
        formData.append('Image', Image === null ? "" : Image);
        formData.append('title', title);
        formData.append('content', content);
        formData.append('startdate', startdate);
        formData.append('enddate', enddate);
        dispatch(updatenews({ selectedId, formData }));
        setImage(null);
        setTitle("");
        setContent("");
        setstartdate("");
        setenddate("");
    }
    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
    const columns = [
        { label: "Title", accessor: "title" },
        { label: "Start Date", accessor: "startdate" },
        { label: "End Date", accessor: "enddate" },
        { label: "Content", accessor: "content" },
        { label: "Date", accessor: "createdAt", formatter: formatDate },
    ];
    return (
        <>
            <div>
                <ToastContainer/>
                <div className='d-flex justify-content-between my-3'>
                    <h3>News</h3>
                    <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  News </button>
                </div>
                <CommanTable
                    columns={columns}
                    data={newss.data || []}
                    status={status}
                    onDelete={handleDelete}
                    onEdit={handlid}
                    databstarget="#exampleModal"
                    model="modal"
                />
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Upload news
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="Image" className="form-label">
                                            Image
                                        </label>
                                        <input
                                            type="file"
                                            required
                                            className="form-control"
                                            id="Image"
                                            name="Image"
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="title" className="form-label">
                                            Title
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            className="form-control"
                                            id="title"
                                            name="title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Title"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="startdate" className="form-label">
                                            startdate
                                        </label>
                                        <input
                                            required
                                            type="date"
                                            className="form-control"
                                            id="startdate"
                                            name="startdate"
                                            value={startdate}
                                            onChange={(e) => setstartdate(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6">
                                        <label htmlFor="enddate" className="form-label">
                                            End Date
                                        </label>
                                        <input
                                            required
                                            type="date"
                                            className="form-control"
                                            id="enddate"
                                            name="enddate"
                                            value={enddate}
                                            onChange={(e) => setenddate(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="content" className="form-label">
                                            Content
                                        </label>
                                        <JoditEditor
                                            required={true}
                                            value={content}
                                            tabIndex={1} // 
                                            onBlur={newContent => setContent(newContent)}
                                            onChange={newContent => { }}
                                        />
                                    </div>
                                    <div className={`modal-footer ${SubmitButton}`}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                            ref={closeButtonRef}
                                        >
                                            Close
                                        </button>
                                        <button type="submit" className={`btn btn-primary`}   >
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div className={`modal-footer ${updateButton}`}>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button type="submit" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal"  >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default News;
